import { useLogout } from '@vis-auth/react';

const Logout = (): null => {
  const logout = useLogout();
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  logout();
  return null;
};

export default Logout;
